import { memo, useState } from "react";
import { Box } from "@mui/material";

import BSZPlannerHeader from "./appHeader/BSZPlannerHeader";
import BSZPlannerContent from "./BSZPlannerContent";

/**
 * =========================================================
 * ✅ BSZ BODY
 * =========================================================
 */
function BszPlannerBody() {
  const [viewMode, setViewMode] = useState("timeline"); // future use

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      {/* ✅ HEADER (fixed) */}
      <BSZPlannerHeader viewMode={viewMode} setViewMode={setViewMode} />

      {/* ✅ SCROLLABLE CONTENT */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0,
          pb: "3rem",
        }}
      >
        <BSZPlannerContent viewMode={viewMode} />
      </Box>
    </Box>
  );
}

export default memo(BszPlannerBody);
